<div id="case-quick-processing" class="container-fluid pb-3">
 
    <div class="row">
        <div class="col-xs-12 offset-sm-6 col-sm-6 offset-md-8 col-md-4 offset-lg-10 col-lg-2 col-xl mb-4">
            <quick-detailed-switch [idPrefix]="'case.'" [caseId]="case?.id"></quick-detailed-switch>
        </div>
    </div>

    <div *ngIf="case">

        <div class="row">

            <div class="col-sm-4">

                <mat-card>

                    <mat-card-title>
                        <div class="row">
                            <div class="col-sm-12">
                                {{ 'quick_processing.title.customer' | translate }}
                            </div>
                        </div>
                    </mat-card-title>

                    <mat-card-content>

                        <!-- Plate number -->
                        <div class="row">
                            <div class="col-sm-10">
                                <div class="row no-gutters">
                                    <mat-form-field class="full-width">
                                        <mat-label>{{ case.vehicle.trans.plate_number | translate }}</mat-label>
                                        <input id="{{idPrefix}}{{case.vehicle.trans.plate_number}}"
                                               type="text" matInput
                                               [(ngModel)]="case.vehicle.plate_number"
                                               (blur)="patchAndUpdate('vehicle.plate_number')"
                                               uppercase>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <address-participant #customerAddress
                                                     [idPrefix]="(idPrefix + customerType + '.')"
                                                     [type]="customerType"
                                                     [config]="customerOptions"
                                                     [typeInLabels]="false">
                                </address-participant>
                            </div>
                        </div>



                        <div class="row mt-4 mb-5" *ngIf="customerAddressParticipantComponent && customerAddressParticipantComponent.participant && customerDisabledTypes">
                            <div class="col-sm-10">
                                <dynamic-checkboxes [idPrefix]="idPrefix + customerType + '.types.'"
                                                    [current]="customerAddressParticipantComponent.participant.type"
                                                    [options]="customerExtraTypes"
                                                    [disabledOptions]="customerDisabledTypes"
                                                    [patchPath]="'type'"
                                                    [checkboxAmountPerRowForScreenSize]="checkboxAmountPerRowForScreenSize"
                                                    (updated)="customerAddressParticipantComponent.patchAndUpdateWithValue($event)">
                                </dynamic-checkboxes>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                    </mat-card-content>
                </mat-card>

            </div>

            <div class="col-sm-4">

                <div class="row">
                    <div class="col-sm-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ case.trans.claim_type| translate }}</mat-label>
                            <mat-select id="{{idPrefix}}{{case.trans.claim_type}}"
                                        [(ngModel)]="selectedClaimType"
                                        [disabled]="disabled">
                                <mat-option *ngFor="let type of claimTypesList?.items; let idx = index"
                                            id="{{idPrefix}}{{case.trans.claim_type}}.item_{{idx}}"
                                            [value]="type">
                                    {{ type.displayName | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-10">
                        <date-time-picker [idPrefix]="(idPrefix + 'claim_date.')"
                                          [date]="case.claim_date"
                                          [time]="case.claim_date_usertime"
                                          [options]="claimDateTimePickerOptions"
                                          [disabled]="disabled"
                                          (multiUpdated)="patchOpDataArray($event)">
                        </date-time-picker>
                    </div>
                    <div class="col-sm-2">
                        <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                    </div>
                </div>

                <quick-processing-switches [idPrefix]="idPrefix" [case]="case" (updated)="patchAndUpdateWithValue($event)"></quick-processing-switches>

                <div class="row">
                    <div class="col-sm-10">
                        <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.persons_injured + '.')"
                                            [inputLabel]="case.trans.persons_injured | translate"
                                            [trueFalseNull]="case.persons_injured"
                                            (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'persons_injured', value: $event })"
                                            class="full-width">
                        </app-boolean-toggle>
                    </div>
                    <div class="col-sm-2">
                        <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                    </div>
                </div>


                <div class="row">
                    <div class="col-sm-10">
                        <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.legal_protection + '.')"
                                            [inputLabel]="case.trans.legal_protection | translate"
                                            [trueFalseNull]="case.legal_protection"
                                            (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'legal_protection', value: $event })"
                                            class="full-width">
                        </app-boolean-toggle>
                    </div>
                    <div class="col-sm-2">
                        <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-10">
                        <app-boolean-toggle [idPrefix]="(idPrefix + case.accident.trans.accident_abroad + '.')"
                                            [inputLabel]="case.accident.trans.accident_abroad | translate"
                                            [trueFalseNull]="case.accident.accident_abroad"
                                            (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'accident.accident_abroad', value: $event })"
                                            class="full-width">
                        </app-boolean-toggle>
                    </div>
                    <div class="col-sm-2">
                        <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                    </div>
                </div>
                                
                <div class="row">
                    <div class="col-sm-10">
                        <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.contributory_fault + '.')"
                                            [inputLabel]="case.trans.contributory_fault | translate"
                                            [trueFalseNull]="case.contributory_fault"
                                            (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'contributory_fault', value: $event })"
                                            class="full-width">
                        </app-boolean-toggle>
                    </div>
                    <div class="col-sm-2">
                        <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                    </div>
                </div>
                                
                <div class="row">
                    <div class="col-sm-10">
                        <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.business_trip + '.')"
                                            [inputLabel]="case.trans.business_trip | translate"
                                            [trueFalseNull]="case.business_trip"
                                            (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'business_trip', value: $event })"
                                            class="full-width">
                        </app-boolean-toggle>
                    </div>
                    <div class="col-sm-2">
                        <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                    </div>
                </div>



                <div class="row">
                    <div class="col-sm-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ case.trans.office | translate }}</mat-label>
                            <mat-select id="{{idPrefix}}{{case.trans.office}}"
                                        [(ngModel)]="selectedOffice"
                                        [disabled]="disabled">
                                <mat-option *ngFor="let office of offices; let idx = index"
                                            id="{{idPrefix}}{{case.trans.office}}.item_{{idx}}"
                                            [value]="office">
                                    {{ office.actionListDisplayName | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-2"></div>
                </div>

                <div class="row">
                    <div class="col-sm-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ ParticipantTypes.SERVICE_CONSULTANT.trans | translate }}</mat-label>
                            <mat-select #serviceConsultantSelect
                                        id="{{idPrefix}}{{ParticipantTypes.SERVICE_CONSULTANT.trans}}"
                                        [(ngModel)]="serviceConsultant"
                                        [disabled]="disabled">
                                <mat-option id="{{idPrefix}}{{ParticipantTypes.SERVICE_CONSULTANT.trans}}.item_empty"></mat-option>
                                <mat-option *ngFor="let potPart of serviceConsultantList; let idx = index"
                                            id="{{idPrefix}}{{ParticipantTypes.SERVICE_CONSULTANT.trans}}.item_{{idx}}"
                                            [value]="potPart">
                                    {{ potPart.displayName | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-2"></div>
                </div>


                <!-- TBD: Transition to Clerk: -->
                    <div class="row">
                        <div class="col-sm-10">
                            <mat-form-field class="full-width">
                                <mat-label>{{ ParticipantTypes.CLERK.trans | translate }}</mat-label>
                                <mat-select #clerkSelect
                                            id="{{idPrefix}}{{ParticipantTypes.CLERK.trans}}"
                                            [(ngModel)]="clerk"
                                            [disabled]="disabled">
                                    <mat-option  id="{{idPrefix}}{{ParticipantTypes.CLERK.trans}}.item_empty"></mat-option>
                                    <mat-option *ngFor="let potPart of clerkList; let idx = index"
                                                id="{{idPrefix}}{{ParticipantTypes.CLERK.trans}}.item_{{idx}}"
                                                [value]="potPart">
                                        {{ potPart.displayName | translate }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-2"></div>
                    </div>


                <div class="row">
                    <div class="col-sm-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ ParticipantTypes.ASSESSOR.trans | translate }}</mat-label>
                            <mat-select #assessorSelect
                                        id="{{idPrefix}}{{ParticipantTypes.ASSESSOR.trans}}"
                                        [(ngModel)]="assessor"
                                        [disabled]="disabled">
                                <mat-option  id="{{idPrefix}}{{ParticipantTypes.ASSESSOR.trans}}.item_empty"></mat-option>
                                <mat-option *ngFor="let potPart of assessorList; let idx = index"
                                            id="{{idPrefix}}{{ParticipantTypes.ASSESSOR.trans}}.item_{{idx}}"
                                            [value]="potPart">
                                    {{ potPart.displayName | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-2"></div>
                </div>

                <div class="row">
                    <div class="col-sm-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ ParticipantTypes.LAWYER.trans | translate }}</mat-label>
                            <mat-select #lawyerSelect
                                        id="{{idPrefix}}{{ParticipantTypes.LAWYER.trans}}"
                                        [(ngModel)]="lawyer"
                                        [disabled]="disabled">
                                <mat-option id="{{idPrefix}}{{ParticipantTypes.LAWYER.trans}}.item_empty"></mat-option>
                                <mat-option *ngFor="let potPart of lawyerList; let idx = index"
                                            id="{{idPrefix}}{{ParticipantTypes.LAWYER.trans}},item_{{idx}}"
                                            [value]="potPart">
                                    {{ potPart.displayName | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-2"> </div>
                </div>


            </div>

            <div class="col-sm-4">

                <mat-card>

                    <mat-card-title>
                        <div class="row">
                            <div class="col-sm-12">
                                {{ 'quick_processing.title.accident_opponent' | translate }}
                            </div>
                        </div>
                    </mat-card-title>

                    <mat-card-content>


                        <div class="row">
                            <div class="col-sm-10">
                                <div class="row no-gutters">
                                    <mat-form-field class="full-width">
                                        <mat-label>{{ case.accident.opponent.trans.plate_number | translate }}</mat-label>
                                        <input id="{{idPrefix}}{{case.accident.opponent.trans.plate_number}}"
                                               type="text" matInput
                                               [(ngModel)]="case.accident.opponent.plate_number"
                                               (blur)="patchAndUpdate('accident.opponent.plate_number')"
                                               uppercase>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <address-participant #accidentOpponentAddress
                                                     [idPrefix]="(idPrefix + accidentOpponentType + '.')"
                                                     [type]="accidentOpponentType"
                                                     [config]="accidentOpponentOptions"
                                                     [typeInLabels]="false">
                                </address-participant>
                            </div>
                        </div>




                    </mat-card-content>

                </mat-card>

                <mat-card class="mt-2">

                    <mat-card-content>

                        <div class="row">
                            <div class="col-sm-10">
                                <address-participant #accidentOpponent2Address
                                                     [idPrefix]="(idPrefix + accidentOpponent2Type + '.')"
                                                     [type]="accidentOpponent2Type"
                                                     [config]="accidentOpponent2Options"
                                                     [typeInLabels]="true">
                                </address-participant>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <div class="row no-gutters">
                                    <mat-form-field class="full-width">
                                        <mat-label>{{ case.trans.insurance_number | translate }}</mat-label>
                                        <input id="{{idPrefix}}{{case.trans.insurance_number}}"
                                               type="text" matInput
                                               [(ngModel)]="case.accident.opponent.insurance_number"
                                               [disabled]="disabled"
                                               (blur)="patchAndUpdate('accident.opponent.insurance_number')">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <div class="row no-gutters">
                                    <mat-form-field class="full-width">
                                        <mat-label>{{ case.trans.claim_number | translate }}</mat-label>
                                        <input id="{{idPrefix}}{{case.trans.claim_number}}"
                                               type="text" matInput
                                               [(ngModel)]="case.accident.opponent.claim_number"
                                               [disabled]="disabled"
                                               (blur)="patchAndUpdate('accident.opponent.claim_number')"
                                        >
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                    </mat-card-content>

                </mat-card>



            </div>
        </div>

        <mat-card class="mt-2">


            <mat-card-content>


                <div class="row no-gutters">
                    <div class="col-sm-12">
                        <div class="row no-gutters">
                            <div class="col-xl col-lg-2 col-md-3 col-sm-4 dr-checkbox-container"
                                 *ngFor="let type of damageTypes; let i = index;"
                                 [ngClass]="{'first-checkbox': i === 0, 'last-checkbox': i === (damageTypes.length - 1)}">
                                <dr-checkbox [idPrefix]="idPrefix"
                                             [idSuffix]="case.accident.trans[type]"
                                             [boolValue]="case.accident[type]"
                                             [label]="case.accident.trans[type]"
                                             [patchPath]="'accident.' + type"
                                             (updated)="patchAndUpdateWithValue($event)">
                                </dr-checkbox>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row no-gutters" style="margin-top: 25px; margin-bottom: 25px;">
                    <div class="col-sm-12">
                        <mat-form-field class="full-width">
                            <mat-label>{{ case.accident.trans.description | translate }}</mat-label>
                            <textarea id="{{idPrefix}}{{case.accident.trans.description}}"
                                      matInput
                                      rows="8"
                                      [(ngModel)]="case.accident.description"
                                      (blur)="patchAndUpdate('accident.description')"
                                      [disabled]="disabled">
                        </textarea>
                        </mat-form-field>
                    </div>
                </div>

            </mat-card-content>

        </mat-card>

    </div>

    <!--
    <div class="row" style="margin-top: 25px;">
        <div class="col-sm-4 offset-sm-8">
            <button id="{{idPrefix}}btn.finish" mat-flat-button color="accent" class="full-width" (click)="finishCaseEditing()">{{ 'quick_processing.btn.finish' | translate }}</button>
        </div>
    </div>
    -->

</div>
